import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Textarea } from "../../components/ui/textarea";

export function AbsencesTab({
  displayName, getSortedStudents, absenceStudent, setAbsenceStudent,
  absenceType, setAbsenceType, absenceNotes, setAbsenceNotes, handleRecordAbsence,
}) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Record / Update Absence</CardTitle>
          <CardDescription>Mark or update student absence status</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Student</Label>
              <Select value={absenceStudent} onValueChange={setAbsenceStudent}>
                <SelectTrigger data-testid="absence-student-select"><SelectValue placeholder="Select student" /></SelectTrigger>
                <SelectContent>
                  {getSortedStudents().map((student) => (
                    <SelectItem key={student.id} value={student.id}>
                      {displayName(student)} {student.last_name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Absence Type</Label>
              <Select value={absenceType} onValueChange={setAbsenceType}>
                <SelectTrigger data-testid="absence-type-select"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="excused">Excused</SelectItem>
                  <SelectItem value="unexcused">Unexcused</SelectItem>
                  <SelectItem value="on_pause">On Pause</SelectItem>
                  <SelectItem value="planned_schedule">Change to Planned Schedule</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="space-y-2">
            <Label>Notes</Label>
            <Textarea placeholder="Add any notes..." value={absenceNotes} onChange={(e) => setAbsenceNotes(e.target.value)} data-testid="absence-notes" />
          </div>
          <Button onClick={handleRecordAbsence} className="bg-[#A62E1D] hover:bg-[#A62E1D]/90" data-testid="record-absence-btn">
            Record Absence
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
